if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmitHandler);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        var _learnq = window._learnq || [];

        if (typeof item !== 'undefined') {
          _learnq.push(['track', 'Added to Cart', item]);
        }
        else {
          // TODO: HOW DO WE GET THE ITEM DATA IF KLAVIYO HASNT FINISHED LOADING OR WERE NOT ON PDP?
        }

        // #TODO: ADD GTM addToCart event here OR SETUP A PUBSUB TO TRIGGER THAT EVENT AND THE ABOVE KLAVIYO EVENT

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            // Safari safety check: ensure response is valid and has json method
            if (!response || typeof response.json !== 'function') {
              console.error('Invalid response object:', response);
              throw new Error('Invalid response from server. Please try again.');
            }
            
            // Check if response is OK, if not try to parse error
            if (!response.ok) {
              // Try to get error message from response
              return response.text().then(text => {
                let errorData;
                try {
                  errorData = JSON.parse(text);
                } catch (e) {
                  // If response isn't JSON, create error object
                  errorData = {
                    status: response.status,
                    message: `HTTP error! Status: ${response.status}`,
                    description: text || `Failed to add item to cart. Status: ${response.status}`
                  };
                }
                throw errorData;
              });
            }
            
            // Check content type to ensure it's JSON (Safari can be strict)
            const contentType = response.headers.get('content-type');
            if (contentType && !contentType.includes('application/json') && !contentType.includes('text/javascript')) {
              return response.text().then(text => {
                throw {
                  status: response.status,
                  message: 'Invalid response format',
                  description: 'Server returned non-JSON response'
                };
              });
            }
            
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;

            var _learnq = _learnq || [];
            var item = item || {};
            _learnq.push(['track', 'Added to Cart', item]);

            // #TODO: ADD GTM addToCart event here OR SETUP A PUBSUB TO TRIGGER THAT EVENT AND THE ABOVE KLAVIYO EVENT

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Add to cart error:', e);
            // Handle error objects that were thrown
            if (e && typeof e === 'object' && (e.status || e.message || e.description)) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: e.errors || e.description,
                message: e.message || 'Failed to add item to cart',
              });
              this.handleErrorMessage(e.description || e.message || 'Failed to add item to cart. Please try again.');
              this.error = true;
            } else {
              // Generic error handling
              this.handleErrorMessage('Failed to add item to cart. Please try again.');
              this.error = true;
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
